var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './index.scss';
import { ContentCardsChildComp } from '../../ContentCardsChildComponent/Index';
import classnames from 'classnames';
var ContentCards = function (props) {
    return (
    // <SectionContent
    //   data={{ title: props.data.title}}
    //   classes={{
    //     container: 'related-content',
    //     header: 'related-content__section-header',
    //   }}
    // >
    //   {/* refactor to Cards component */}
    //   <div
    //     className={classnames(
    //       'w-full h-auto flex justify-between items-stretch maxmd:overflow-x-hidden',
    //       'related-content__cards',
    //     )}
    //   >
    //     {/* {props.data.contentCardList.map((item : any, index: number)=>(
    //     <ArticleRelatedCard
    //       title={item.title}
    //       date={item.date}
    //       image={item.image}
    //     />
    //   ))} */}
    //   <ContentCardsChildComp data={props}/>
    //     {/* <ArticleRelatedCard
    //       title={props.data.contentCardList[0].title}
    //       date="11 OCT 2021"
    //       image={StoryImage1}
    //     />
    //     <ArticleRelatedCard
    //       title="Why Individual Stock Selection Is A Bad Approach To Investing"
    //       date="11 OCT 2021"
    //       image={StoryImage2}
    //     />
    //     <ArticleRelatedCard
    //       title="Momentum Stocks: Does Popularity Result In Profitability?"
    //       date="11 OCT 2021"
    //       image={StoryImage3}
    //     /> */}
    //   </div>
    //   {/* <Pagnation /> */}
    // </SectionContent>
    _jsx(ContentCardsChildComp, { data: props }, void 0));
};
export var Pagnation = function () { return (_jsxs("div", __assign({ className: classnames('my-4', 'related-content__dots') }, { children: [_jsx("div", { className: 'related-content__dot--blue' }, void 0),
        _jsx("div", { className: 'related-content__dot' }, void 0),
        _jsx("div", { className: 'related-content__dot' }, void 0)] }), void 0)); };
export default ContentCards;
